import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {useHistory} from "react-router-dom";

import DateRangePicker from "components/DateRangePicker";
import OrderSearchBar from "../../OrderSearchBar";
import MobileIconButton from "./MobileIconButton";

import {OrderListContext} from "views/oms/OrderList/context/OrderListContext";
import {isPeriodNeutralized} from "views/oms/OrderList/utils/isPeriodNeutralized";

import {black500} from "assets/jss/main";

MobileHeader.propTypes = {
    search: PropTypes.string,
    setSearch: PropTypes.func
};

const ArrowLeftIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.975 4.94167L2.91667 10L7.975 15.0583" stroke="#333333" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17.0833 10H3.05833" stroke="#333333" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const SearchIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.66667 14C11.1645 14 14 11.1645 14 7.66667C14 4.16886 11.1645 1.33333 7.66667 1.33333C4.16886 1.33333 1.33333 4.16886 1.33333 7.66667C1.33333 11.1645 4.16886 14 7.66667 14Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.6667 14.6667L13.3333 13.3333" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const CalendarIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.33333 1.33333V3.33333" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10.6667 1.33333V3.33333" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2.33333 6.06H13.6667" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14 5.66667V11.3333C14 13.3333 13 14.6667 10.6667 14.6667H5.33333C3 14.6667 2 13.3333 2 11.3333V5.66667C2 3.66667 3 2.33333 5.33333 2.33333H10.6667C13 2.33333 14 3.66667 14 5.66667Z" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

// mobile equivalent of the desktop Page header: back arrow + title, and the
// search/date pickers are tucked behind icons instead of always visible
function MobileHeader({search, setSearch}) {
    const history = useHistory();
    const {queryParams} = useContext(OrderListContext);

    const [searchOpen, setSearchOpen] = useState(false);
    const [dateOpen, setDateOpen] = useState(false);

    return (
        <div style={{backgroundColor: 'white', borderBottom: '1px solid #e6e7eb'}}>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px'}}>
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    <div onClick={() => history.goBack()} style={{cursor: 'pointer', display: 'flex'}}>
                        <ArrowLeftIcon />
                    </div>
                    <span style={{color: black500, fontWeight: 600, fontSize: '16px'}}>
                        <FormattedMessage id='oms.order.list.title' />
                    </span>
                </div>

                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    <MobileIconButton onClick={() => setSearchOpen(!searchOpen)}>
                        <SearchIcon />
                    </MobileIconButton>
                    <MobileIconButton color="#3c81fb" onClick={() => setDateOpen(!dateOpen)}>
                        <CalendarIcon />
                    </MobileIconButton>
                </div>
            </div>

            {(searchOpen || dateOpen) && (
                <div style={{display: 'flex', flexDirection: 'column', gap: '8px', padding: '0 16px 16px'}}>
                    {searchOpen && <OrderSearchBar search={search} setSearch={setSearch} />}
                    {dateOpen && <DateRangePicker displayFormat={'DD/MM/YYYY'} compact suspended={!!search || isPeriodNeutralized(new URLSearchParams(queryParams))} />}
                </div>
            )}
        </div>
    );
}

export default MobileHeader;
